import React from 'react';

const Hero = () => {
  return (
    <section className="text-center py-16">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="font-bold text-gray-900 mb-4">
          <span className="text-2xl sm:text-3xl md:text-5xl whitespace-nowrap block">High Impact Social Video Ads</span>
          <span className="text-2xl sm:text-3xl md:text-5xl bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent inline-block mb-2 leading-relaxed whitespace-nowrap">Predict. Improve. Win.</span>
        </h1>
        
        <h2 className="text-xs sm:text-sm md:text-base lg:text-lg text-gray-600 mb-6 font-serif italic">
          Built on Industry-leading Conversion & Storytelling Frameworks
        </h2>
        
        <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
          Analyze your ads against proven frameworks to know their strength before you invest. Get actionable insights to fix critical flaws, prevent wasted ad spend and maximize your ROI
        </p>
      </div>
    </section>
  );
};

export default Hero;
